export default "__VITE_ASSET__0fCo8ZoD__"